<template>
  <div class="fixed inset-0 z-50">
    <SiteMenuFlyoutLayout :heading="heading" @close="$emit('close')">
      <div class="space-y-4">
        <button
          v-for="(menu, menuKey) in combinedMenus"
          :key="menuKey"
          class="w-full bg-white rounded-lg p-7 relative z-10 overflow-hidden text-left focus:outline-none"
          :style="{
            backgroundColor: menuThemes[menuKey][0],
            color: menuThemes[menuKey][1],
          }"
          @click="openMenu(menuKey)"
        >
          <div class="w-60 max-w-full space-y-5">
            <h4 class="text-lg font-semibold">{{ menu.heading }}</h4>
            <p v-if="menu.description" class="text-sm">
              {{ menu.description }}
            </p>
          </div>

          <InlineSvg
            v-if="menu.backgroundImage.length"
            class="w-full h-auto absolute left-0 top-0 -z-10"
            :src="menu.backgroundImage[0].url"
            :transform-source="removeSvgFill"
            :fill="menu.backgroundImageColour"
          />
        </button>
      </div>
    </SiteMenuFlyoutLayout>

    <transition name="fade">
      <SiteMenuFlyoutMegaPrimary
        v-if="isOpenedMenu(PRIMARY_KEY)"
        :theme="menuThemes[PRIMARY_KEY]"
        :heading="primaryMenu.heading"
        :items="primaryMenu.items"
        @close="closeMenu"
      />
    </transition>

    <transition name="fade">
      <SiteMenuFlyoutMegaSecondary
        v-if="isOpenedMenu(SECONDARY_KEY)"
        :theme="menuThemes[SECONDARY_KEY]"
        :heading="secondaryMenu.heading"
        :items="secondaryMenu.items"
        :background-image-colour="secondaryMenu.backgroundImageColour"
        @close="closeMenu"
      />
    </transition>
  </div>
</template>

<script>
import InlineSvg from "vue-inline-svg";
import SiteMenuFlyoutMixin from "./SiteMenuFlyoutMixin.vue";
import SiteMenuFlyoutMegaPrimary from "./SiteMenuFlyoutMegaPrimary.vue";
import SiteMenuFlyoutMegaSecondary from "./SiteMenuFlyoutMegaSecondary.vue";
import { removeSvgFill } from "../../js/utils";

export default {
  name: "SiteMenuFlyoutMega",

  components: {
    InlineSvg,
    SiteMenuFlyoutMegaPrimary,
    SiteMenuFlyoutMegaSecondary,
  },

  mixins: [SiteMenuFlyoutMixin],

  props: {
    menuData: {
      type: Object,
      required: true,
    },
  },

  computed: {
    PRIMARY_KEY: () => "primary",
    SECONDARY_KEY: () => "secondary",
    primaryMenu() {
      const [primarySectionData] = this.menuData.primarySection;
      const {
        backgroundColour,
        backgroundImage,
        backgroundImageColour,
        textColour,
        heading,
        description,
      } = primarySectionData;
      const items = primarySectionData.columns.map((column) => {
        const menu = this.removeEmptyElements(column.menu)[0] || null;
        const ctas = this.removeEmptyElements(column.ctas)[0]?.children || [];
        return { menu, ctas };
      });
      return {
        backgroundColour,
        backgroundImage,
        backgroundImageColour,
        textColour,
        heading,
        description,
        items,
      };
    },
    secondaryMenu() {
      const [secondarySectionData] = this.menuData.secondarySection;
      const {
        backgroundColour,
        backgroundImage,
        backgroundImageColour,
        textColour,
        heading,
        description,
      } = secondarySectionData;
      return {
        backgroundColour,
        backgroundImage,
        backgroundImageColour,
        textColour,
        heading,
        description,
        items: secondarySectionData.menu,
      };
    },
    combinedMenus() {
      const combined = {};
      combined[this.PRIMARY_KEY] = this.primaryMenu;
      combined[this.SECONDARY_KEY] = this.secondaryMenu;

      return combined;
    },
    menuThemes() {
      const themes = {};
      themes[this.PRIMARY_KEY] = [
        this.primaryMenu.backgroundColour,
        this.primaryMenu.textColour,
      ];
      themes[this.SECONDARY_KEY] = [
        this.secondaryMenu.backgroundColour,
        this.primaryMenu.textColour,
      ];

      return themes;
    },
  },

  methods: {
    removeSvgFill,
  },
};
</script>
